import { BoxProps } from "@/ui";
import { Box } from "@chakra-ui/react";
import { FunctionComponent } from "react";

type Props<T> = {
  in: boolean;
  children: React.ReactNode[];
  props?: BoxProps;
  component?: FunctionComponent<T> | typeof Box;
};

export default function FadeToggle<T>({ in: shouldRender, children, props, component: Component = Box }: Props<T>) {

  return (
    <Component {...({ ...props, pos: "relative" } as T)}>
      <Box w="100%" as="span" pos="absolute" left={0} top={0} transition="opacity 0.2s" opacity={!shouldRender ? 1 : 0}>
        {children[0]}
      </Box>
      <Box w="100%" as="span" pos="absolute" left={0} top={0} transition="opacity 0.2s" opacity={shouldRender ? 1 : 0}>
        {children[1]}
      </Box>
      <Box as="span" visibility="hidden" display="grid">
        <Box as="span" gridArea="1/1">{children[0]}</Box>
        <Box as="span" gridArea="1/1">{children[1]}</Box>
      </Box>
    </Component>
  );
}
